export type Partner = {
  height: number;
  width: number;
  heightM: number;
  widthM: number;
  alt: string;
  src: string;
};

export const PARTNERSHIPS: Partner[][] = [
  [
    {
      height: 38,
      width: 202,
      heightM: 19,
      widthM: 101,
      alt: 'uber-freight',
      src: '/images/uber-freight.webp',
    },
    {
      height: 30,
      width: 134,
      heightM: 15,
      widthM: 51,
      alt: 'echo',
      src: '/images/echo.webp',
    },
    {
      height: 69,
      width: 198,
      heightM: 30,
      widthM: 100,
      alt: 'kerry',
      src: '/images/kerry.webp',
    },
    {
      height: 64,
      width: 205,
      heightM: 32,
      widthM: 102,
      alt: 'cqc',
      src: '/images/cqc.webp',
    },
    {
      height: 56,
      width: 251,
      heightM: 28,
      widthM: 126,
      alt: 'robinson',
      src: '/images/robinson.webp',
    },
  ],
  [
    {
      height: 31,
      width: 239,
      heightM: 15,
      widthM: 120,
      alt: 'arrive-logistics',
      src: '/images/arrive-logistics.png',
    },
    {
      height: 30,
      width: 85,
      heightM: 15,
      widthM: 42,
      alt: 'rxo',
      src: '/images/rxo.webp',
    },
    {
      height: 53,
      width: 204,
      heightM: 27,
      widthM: 102,
      alt: 'sherwin-williams',
      src: '/images/sherwin-williams.webp',
    },
    {
      height: 62,
      width: 210,
      heightM: 31,
      widthM: 105,
      alt: 'lineage',
      src: '/images/lineage.webp',
    },
  ],
];
